module.exports = __webpack_public_path__ + "static/media/chart-dot.a4723044.svg";